import { createFileRoute } from '@tanstack/react-router'
import { DashboardLayout } from '@/features/dashboard/components/DashboardLayout'
import { authKeys, currentUserQueryOptions } from '@/features/auth/queries'
import type { User } from '@/features/auth/schema'
import { useAuthStore } from '@/features/auth/store'
import { requireAuthentication } from '@/features/auth/route-access'
import { isCancelledError } from '@/lib/api/errors'
import { ensureQueryData } from '@/lib/query-client'

/**
 * Pathless guard layout. Any route file named `_authed.*` sits behind this
 * check without adding a URL segment.
 */
export const Route = createFileRoute('/_authed')({
  pendingMs: 0,
  pendingMinMs: 0,
  beforeLoad: async ({ context }) => {
    // No `redirect` search param: never restore a previous account's page.
    requireAuthentication()

    const cached = context.queryClient.getQueryData<User>(authKeys.me())
    if (cached) useAuthStore.getState().setUser(cached)

    try {
      const user = await ensureQueryData(context.queryClient, currentUserQueryOptions())
      useAuthStore.getState().setUser(user)
    } catch (error) {
      if (isCancelledError(error)) return
      // Keep the persisted session user if profile/me is briefly unavailable.
    }
  },
  component: AuthedLayout,
})

function AuthedLayout() {
  return <DashboardLayout />
}
